export default __webpack_public_path__ + "static/anypayload-black-0f8914dd6bf8fd538513086f977eee4a.png";